<template>
   <main>
      <section>
         <div class="container pt-2 pb-4">
            <div class="row justify-content-between">

               <div class="col-12 col-md-6 mb-4">         
                  <intro :full="true">
                     <template v-slot:title>{{intro.titolo}}</template> 
                     <template v-slot:intro>{{intro.breve}}</template>
                  </intro>
                  <searchArea 
                     :full="false" 
                     :where="'intro'"
                     :query="this.query"
                     :argomentoSelected = "this.argomento"
                     v-on:queryWatcher="setQuery($event)"
                     v-on:clearSearch="clearSearch()"
                     v-on:setArgSelected="setArgomento($event)"       
                     v-on:setPeriod="setPeriod($event)"
                     ref="searchArea"
                  />
               </div>
               
               <div class="col-12 col-md-4 mt-3">
                  <shareArea :url="this.$route.path"></shareArea>
                  <!-- newsletter></newsletter -->
               </div>
            </div>
         </div>
      </section>
      
      <section class="section section-inset-shadow pb-0 pt-2 pb-5">
         <div id="content" class="container pt-2 pb-4 px-0 px-md-3 pt-5">
                           
            <h3 class="pt-3">Notizie</h3>
            <div class="row">
               <!--div class="col-12 col-md-3" v-if="searched">
                  <div class="panel mt-4">
                     <facets 
                        :facetsResults="facetsResult" 
                        :facetWithResults="facetWithResults"
                        :facetSelected="facetSelected"                    
                        :argomentoSelected = "argomento"
                        v-on:listenSChanged = "setFacetSChanged($event)"
                        v-on:listenAreaChanged = "setFacetAreaChanged($event)"
                        v-on:listenArgsChanged = "setFacetArgsChanged($event)"
                     />              
                  </div>
               </div-->
            
               <!--div v-if="pager.totalResults > 0"
                  :class="[
                     {[`col-12 col-md-9`]: searched},
                     {[`col-12`]: !searched}
                  ]"-->     
                  <div v-if="pager.totalResults > 0" class="col-12">
                  <div class="d-flex small align-items-center justify-content-between" v-if="searched">
                     <div class="text-left">Trovati {{data.total.value}} risultati</div>
                     <div class="align-items-center d-flex">
                        <span>Ordina per </span>
                        <b-form-select class="form-control-sm small bordered ml-1" value-field="value" text-field="text" v-model="sortBy.selected" :options="sortBy.sorting" @change="changeSorting"/>
                     </div>                                  
                  </div>
                  <div class="row">
                     <!-- Call cards -->                                                            
                     <result v-for="(item, index) in data.hits" :news="{item}" :key="index" :ref="`card_${index}`"></result>
                  </div>
               </div>

               <div class="col-12 col-md-9"  v-if="!pager.totalResults > 0 && searched">
                  <div class="alert alert-danger m-4">
                     La ricerca di <b v-if="this.query !== ''">- {{ this.query }} -</b> non ha prodotto risultati in nessun risultato.
                  </div>
               </div>
            </div>

            <div v-if="pager.totalResults > pager.limit">
               <pager :pager="pager" use-router v-if="pager.totalResults > 0" v-on:listenChangePage="changePage($event)" v-on:listenLimitChange="setLimit($event)"/>
            </div>

         </div>

      </section>      
   </main>
</template>
<script>
import { getPage } from './../service';
import searchArea from "@/components/SearchArea.vue";
import shareArea from "@/components/ShareArea";
import intro from "@/components/Intro";
import result from '@/components/Results';
import pager from '@/components/Pager';
//import facets from '@/components/Facets';
//import newsletter from "@/components/Newsletter";
import axios from 'axios';

export default {
   name: "SectionListNotizie",
   
   components: {
      intro,
      searchArea,
      shareArea,
      //newsletter,
      result,
      //facets,
      pager  
   },

   title() {
      let pageTitle = this.$route.name;
      return pageTitle;
   },   

   data() {
      return {
         errors: [],
         searched: false,
         intro:{
            titolo: "Notizie",
            breve: "In questa sezione sono pubblicate le notizie in ordine cronologico.",
         },
         notizie: [],
         specializzazione: [],
         sortBy:{
            selected: '_score',
            sorting: [
               { value: "_score", text: 'Rilevanza' },
               { value: {"data.titolo.iv.keyword": {"order" : "asc"}}, text: 'Titolo A-Z' },
               { value: {"data.titolo.iv.keyword": {"order" : "desc"}}, text: 'Titolo Z-A' },
               { value: {"created": {"order" : "desc"}}, text: 'Più recente' },
               { value: {"created": {"order" : "asc"}}, text: 'Meno recente' },
            ]
         },          
         sort:{
               "data.calendarioEventi.iv.dataDal": {
                  "order": "desc"
               }
            }  
         ,

         /*********************
          * Argomenti "Periodo" selezionato tramite il filtro
          *********************/
         period: {
            active: false,
            dal: '',
            al: ''
         },

         /*********************
          * Parole cercata
          *********************/
         query: '',
         tipo: '',
         tipologia: '',

         /*********************
          * Argomenti selezionato tramite il filtro
          *********************/
         argomento: [],

         filters: [],
         pager:{
            currentPage: 1,
            totalResults: 0,
            from: 0,
            limit: 9
         },                     
         data: [],

         /*********************
          * Questo sono i facet che hanno un count > 0
          *********************/
         facetWithResults: {
            S3: [],
            Aree: [],
            Args: []
         },

         /*********************
          * Questo sono i facet selezionati dal utente
          * L'utente puo aggiungere o togliere
          *********************/
         facetSelected: {
            S3: [],
            Aree: [],
            Args: []
         },
         /*************************
          * Results from search
          *************************/
         facetsResult: []                        
      }
   },

   methods:{
      loadIntro: async function(id){         
         try {                     
            const result = await getPage(id, 'blocco');
            this.intro = this.parseArticle(result);
         } catch (ex) {
            console.log('Falito caricamento intro o insesistente');      
         }         
      },

      parseArticle: function(response){
         return {
            id:            response.id,
            area:          response.schemaDisplayName,
            titolo:        response.data.titolo.iv,
            breve:         response.data.breve.iv,
            slug:          response.data.slug.iv
         }
      },   


      changePage(value){
         this.pager.from = this.pager.limit * (value - 1);
         this.pager.currentPage = value;         
         this.search();
      },

      changeSorting(event) {
         if(event == '_score'){
            this.sort = [{"_score": {"order":"desc"}}];
         }
         else{         
            this.sort = event;
         }
         this.search();
      },

      checkSearch(val){
         if(val == 0 && this.query == ''){
            alert();
            this.clearSearch();
         }
      },

      clearSearch(){         
         this.query = '';
         this.argomento = [];
         this.dal = this.al = null;
         this.setSearched(false);
         this.search();
      },

      getDates(dateToChange){
         const convDate = dateToChange.split('/');
         return convDate[2] + '-' + convDate[1] + '-' + convDate[0];
      },      

      setArgomento: function(arr){
         this.argomento = arr;
         this.search();
      },      

      /*****************************
       * function: setFacetWithResultsAfterSearch
       * args: object 
       * description: Ogni ricerca svuota gli argomenti e resetta le facet selezionato
       ******************************/
      setFacetWithResultsAfterSearch(results){
         this.facetWithResults.S3 = [];
         this.facetWithResults.Aree = [];
         this.facetWithResults.Args = [];         

         if(results["S3"].buckets.length > 0){
            for (let key of Object.keys(results["S3"].buckets)) {               
               this.facetWithResults.S3.push(results["S3"].buckets[key].key);
            }             
         }

         if(results["Aree Specializzazione"].buckets.length > 0){
            for (let key of Object.keys(results["Aree Specializzazione"].buckets)) {
               this.facetWithResults.Aree.push(results["Aree Specializzazione"].buckets[key].key);
            }
         }

         if(results["Argomenti"].buckets.length > 0){
            for (let key of Object.keys(results["Argomenti"].buckets)) {
               this.facetWithResults.Args.push(results["Argomenti"].buckets[key].key);               
            }
         }
      },

      /*****************************
       * function: setFacetSelected
       * args: object 
       * description: Ogni ricerca svuota gli argomenti e resetta le facet selezionato
       ******************************/
//      setFacetSelected(results){
//         this.facetSelected.S3 = [];
//         this.facetSelected.Aree = [];
//         this.facetSelected.Args = [];         
//
//         if(results["S3"].buckets.length > 0){
//            for (let key of Object.keys(results["S3"].buckets)) {               
//               this.facetSelected.S3.push(results["S3"].buckets[key].key);
//            }             
//         }
//
//         if(results["Aree Specializzazione"].buckets.length > 0){
//            for (let key of Object.keys(results["Aree Specializzazione"].buckets)) {
//               this.facetSelected.Aree.push(results["Aree Specializzazione"].buckets[key].key);
//            }
//         }
//
//         if(results["Argomenti"].buckets.length > 0){
//            for (let key of Object.keys(results["Argomenti"].buckets)) {
//               this.facetSelected.Args.push(results["Argomenti"].buckets[key].key);               
//            }
//         }
//      },      
//
//      setFacetSChanged: function(arr){
//         this.facetSelected.S3 = arr;
//          this.search();
//      },
//
//      setFacetAreaChanged: function(arr){
//         this.facetSelected.Aree = arr;
//          this.search();
//      },
//
//      setFacetArgsChanged: function(arr){
//         this.facetSelected.Args = arr;
//          this.search();
//      }, 
      

      setFilters(){           
         if(this.argomento != ''){
            this.filters.push({terms : {"data.argomenti.iv.keyword": this.argomento }});            
         }
         if(this.facetSelected.Args.length > 0){
            this.filters.push({terms : {"data.argomenti.iv.keyword": this.facetSelected.Args }})
         }
         if(this.facetSelected.S3.length > 0){
            this.filters.push({terms : {"data.s3.iv.keyword": this.facetSelected.S3 }});
         }
         if(this.facetSelected.Aree.length > 0){
            this.filters.push({terms : {"data.areeSpecializzazione.iv.keyword": this.facetSelected.Aree }});
         }         

         if(this.period.active){
            if(this.who == 'EventoPublished'){
               this.filters.push({ range: { "data.calendarioEventi.iv.dataDal" : { "gte": this.getDates(this.period.dal), "lte": this.getDates(this.period.al) }}});
            }else{
               this.filters.push({ range: { "lastModified" : { "gte": this.getDates(this.period.dal), "lte": this.getDates(this.period.al) }}});
            }
         }

         if(this.argomento != '' || this.period.active){
            this.searched = true;
         }
         else if(this.argomento && !this.period.active){
            this.searched = false;
         }
      },

      setLimit(value){
         this.pager.limit = value;
         this.search();
      },   

      /*********************
       * SET PERIOD FILTER
       *********************/ 
      setPeriod(value){
         this.period = value;
      },

      setQuery(value){
         this.query = value;
         if(this.query.length < 3 && this.argomento.length == 0 && !this.period.active){ return false; }
         this.search();
         this.setSearched(true);
      },

      getQuery(){
         if(this.query.length === 0){
            return '*';
         }
         else{
            return this.query + '*';
         }
      },

      setSearched: function(val){
         this.searched = val;
      },

      search() {             
         this.filters = [({term: {"name.keyword" : this.tipo}})];
         if(this.argomento.length > 0 || this.period.active || this.facetSelected.S3.length > 0 || this.facetSelected.Aree.length || this.facetSelected.Args.length){
            this.setFilters();
         }
         else{
            this.filters = [({term: {"name.keyword" : this.tipo}})];
         }

         axios.post(process.env.VUE_APP_ESEARCH_PROTOCOL+process.env.VUE_APP_ESEARCH+'/'+process.env.VUE_APP_ESEARCH_INDEX+'/_search',
            {
               "size": this.pager.limit,
               "from" : this.pager.from,   
               "track_scores": true,
               "aggs": {
                  "S3": {
                     "terms": {
                        "field": "data.s3.iv.keyword",
                        "size": 10
                     }
                  },
                  "Aree Specializzazione": {
                     "terms": {
                        "field": "data.areeSpecializzazione.iv.keyword",
                        "size": 10
                     }
                  },
                  "Argomenti": {
                     "terms": {
                        "field": "data.argomenti.iv.keyword",
                        "size": 40
                     }
                  }
               },
               "_source": {
                  "excludes": [ "timestamp", "appId", "createdBy", "actor", "version", "partition"]
               },                    
               "sort" : this.sort,          
               "query": {
                  "bool": {
                     "must": {
                        "simple_query_string": {
                           "query": this.getQuery(),
                           "flags": "ALL",
                           "fuzzy_transpositions": true,
                           "fuzzy_max_expansions": 50,
                           "fuzzy_prefix_length": 0,
                           "minimum_should_match": 1,
                           "default_operator": "or",
                           "lenient": true,
                           "analyzer": "standard",
                           "quote_field_suffix": "",
                           "analyze_wildcard": true,
                           "auto_generate_synonyms_phrase_query": true
                        }
                     },                    
                     "filter": this.filters
                  }
               }                  
            },
            {
               auth: { 
                  username: process.env.VUE_APP_ESEARCH_CREDENTIALS_USER,
                  password: process.env.VUE_APP_ESEARCH_CREDENTIALS_PASS
               }
            }
         ).then(response => {
            this.data = response.data.hits;
            this.facetsResult = response.data.aggregations;
            this.pager.totalResults = response.data.hits.total.value;   
            this.setFacetWithResultsAfterSearch(this.facetsResult);
         })
      },                                        
   },

   created(){
      this.tipo = this.$route.meta.tipologia;
      this.loadIntro(this.$route.path.substring(+1));      
   },

   mounted() {
      this.search();
   },

};
</script>